const renderDate = (dateToRender: string) => {
// console.log("DATE UPDATED : ", seo.dateUpdated);
const date = new Date(dateToRender);
// console.log("DATE : ", date);
// console.log("MONTH : ", date.getUTCMonth());

return (
    formatNumberToTwoCharacters(date.getMonth() + 1) +
    "/" +
    formatNumberToTwoCharacters(date.getDate()) +
    "/" +
    date.getFullYear().toString() +
    " at " +
    formatNumberToTwoCharacters(date.getHours()) +
    ":" +
    formatNumberToTwoCharacters(date.getMinutes())
);
};

const formatNumberToTwoCharacters = (number: number) => {
return number < 10 ? "0" + number.toString() : number.toString();
};

export default renderDate